module.exports = __webpack_public_path__ + "img/ring_y_0_1_null@3x.2c8a3e4b.png";